import { BoxAction, OosDetectionState } from '../../../types';

type OosDetectionFormProps = {
  action: BoxAction;
  onUpdateAction: (bboxId: number, updates: Partial<BoxAction>) => void;
};

export const OosDetectionForm: React.FC<OosDetectionFormProps> = ({ action, onUpdateAction }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">OOS Detection</label>
      <select
        value={action.oosDetection || ''}
        onChange={(e) =>
          onUpdateAction(action.bboxId, {
            oosDetection: e.target.value as OosDetectionState,
          })
        }
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">Select detection</option>
        <option value="out">Out of stock</option>
        <option value="low">Low</option>
        <option value="in">In</option>
        <option value="zin">Zero Inventory In</option>
        <option value="n/a">N/A</option>
      </select>
    </div>
  );
};
